import React from "react";
import { ExamDayViewModel } from "../../model/ExamDayViewModel";
import CustomCard from "../common/CustomCard";
import LocaleFormatDate from "../common/dates/LocaleFormatDate";
import TranslatedMessage from "../translations/TranslatedMessage";
import { ExamFormatLabels } from "../../model/ExamDayType";

type ExamDayCardProps = {
  examDay: ExamDayViewModel;
  onClick?: (examDayId: string) => void;
};

const ExamDayCard: React.FunctionComponent<ExamDayCardProps> = ({ examDay, onClick }) => {
  const handleClick = () => onClick!(examDay.id);

  return (
    <CustomCard
      line3={
        <span>
          <TranslatedMessage id="examDay.field.numberOfRoomsAssigned" /> {examDay.roomAssignments.length}
        </span>
      }
      line1={<LocaleFormatDate date={examDay.date} />}
      line2={<TranslatedMessage id={ExamFormatLabels[examDay.type]} />}
      onClick={handleClick}
    />
  );
};

export default ExamDayCard;
